<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header">
      <h2>Kalendarz</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <b-container fluid>
        <b-row class="justify-content-center" v-if="!loaded && loading">
          <b-spinner big label="Loading..."></b-spinner>
        </b-row>

        <b-row v-else-if="loaded">
          <b-container fluid>
            <b-row style="margin-bottom: 8px;">
              <b-col style="padding: 0px;">
                <b-form-group class="required" label="Lektorzy">
                  <multiselect
                    v-model="selectedLectors"
                    track-by="id"
                    label="displayName"
                    placeholder="Wybierz lektorów"
                    :options="lectorsProfiles"
                    :allow-empty="true"
                    :multiple="true"
                    :internal-search="false"
                    :searchable="false"
                  >
                    <template slot="singleLabel" slot-scope="{option}">
                      <span>{{ option.firstName }} {{ option.lastName }}</span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <span>{{ props.option.firstName }} {{ props.option.lastName }}</span>
                    </template>
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <vue-cal
                v-if="selectedLectors.length > 0"
                locale="pl"
                default-view="day"
                :time-from="6*60"
                :time-to="23*60"
                :time-step="20"
                :hide-weekdays="[7]"
                :disable-views="['years', 'year', 'month', 'week', 'day']"
                :events="events"
                :on-event-click="onEventClick"
                :split-days="splitDays"
                :sticky-split-labels="true"
                @view-change="reloadEvents('view-change', $event)"
                class="vuecal--blue-theme"
              >
                <template
                  v-slot:title="{ title, view }"
                >Dzień: {{ (view.startDate.getDate() < 10 ? '0' : '') }}{{ view.startDate.getDate() }}.{{ (view.startDate.getMonth() + 1 < 10 ? '0' : '') }}{{ view.startDate.getMonth() + 1 }}.{{ view.startDate.getFullYear() }}</template>
              </vue-cal>
            </b-row>
          </b-container>
        </b-row>

        <b-modal v-model="showEventDetailsModal" ref="eventDetailsModal">
          <template slot="modal-title">{{this.selectedEvent.name}}</template>

          <b-container>
            <b-row>
              <b-col>Data:</b-col>
              <b-col>
                {{this.selectedEvent.start}}
                <div v-if="this.selectedEvent.type < 2">{{this.selectedEvent.end}}</div>
              </b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.type > 1">
              <b-col>Kursant:</b-col>
              <b-col>{{this.selectedEvent.interlocutor}}</b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.type > 1">
              <b-col>Telefon:</b-col>
              <b-col>{{this.selectedEvent.phone}}</b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.type > 1">
              <b-col>Skype:</b-col>
              <b-col>
                <a
                  :href="'skype:' + this.selectedEvent.skype + '?call'"
                >{{this.selectedEvent.skype}}</a>
              </b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.price">
              <b-col>Cena zajęć:</b-col>
              <b-col>{{this.selectedEvent.price.toFixed(2)}} PLN</b-col>
            </b-row>
            <b-row v-if="this.subjects != null">
              <b-col>Tematy:</b-col>
              <b-col>{{this.subjects}}</b-col>
            </b-row>
            <b-row v-if="this.currentWords != null">
              <b-col>Słówka:</b-col>
              <b-col>{{this.currentWords}}</b-col>
            </b-row>
            <b-row v-if="this.previousWords != null">
              <b-col>Poprzednie:</b-col>
              <b-col>{{this.previousWords}}</b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.type > 1 && this.selectedEvent.type < 5">
              <b-col>Ocena:</b-col>
              <b-col>{{this.selectedEvent.rating}}</b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.type > 1 && this.selectedEvent.type < 5">
              <b-col>Komentarz:</b-col>
              <b-col>
                <span v-html="this.selectedEvent.comment"></span>
              </b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.type > 4">
              <b-col>Opis dla kursanta:</b-col>
              <b-col>
                <span v-html="this.selectedEvent.descriptionForStudent"></span>
              </b-col>
            </b-row>
            <b-row v-if="this.selectedEvent.type > 4">
              <b-col>Opis dla lektora:</b-col>
              <b-col>
                <span v-html="this.selectedEvent.descriptionForLector"></span>
              </b-col>
            </b-row>
          </b-container>

          <template slot="modal-footer" slot-scope="{ ok }">
            <b-container>
              <b-row>
                <b-col style="text-align: right; padding-right: 0px;">
                  <b-button variant="primary" @click="ok()">OK</b-button>
                </b-col>
              </b-row>
            </b-container>
          </template>
        </b-modal>
      </b-container>
    </b-row>
  </b-container>
</template>

<script>
var qs = require("qs");

import { axios, eventBus } from "@/_infrastructure";

import moment from "moment";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/pl.js";
import "vue-cal/dist/vuecal.css";
import multiselect from "vue-multiselect";

export default {
  components: { VueCal, multiselect },
  data() {
    return {
      dateOptions: {
        format: "YYYY-MM-DD",
        locale: "pl",
        useCurrent: true
      },
      loading: false,
      loaded: false,
      showEventDetailsModal: false,
      weekDay: 1,
      weekDays: [
        { value: 1, text: "Poniedziałek" },
        { value: 2, text: "Wtorek" },
        { value: 3, text: "Środa" },
        { value: 4, text: "Czwartek" },
        { value: 5, text: "Piątek" },
        { value: 6, text: "Sobota" }
      ],
      interlocutor: null,
      selectedEvent: {},
      events: [],
      lectorsIds: [],
      lectorsProfiles: [],
      selectedLectors: [],
      from: moment(new Date()).format("YYYY-MM-DD"),
      to: moment(new Date().addDays(1)).format("YYYY-MM-DD"),
      splitDays: [],
      subjects: null,
      currentWords: null,
      previousWords: null
    };
  },
  methods: {
    lectorsChanged() {
      let self = this;

      for (var i = 0; i < this.selectedLectors.length; ++i) {
        let lector = this.selectedLectors[i];

        if (
          !this.splitDays.some(function(item) {
            return item.id == lector.id;
          })
        ) {
          this.splitDays.push({
            id: lector.id,
            class: i % 2 == 0 ? "even" : "odd",
            label: lector.firstName + " " + lector.lastName
          });
        }
      }

      this.splitDays = this.splitDays.filter(function(item) {
        return self.selectedLectors.some(function(item2) {
          return item2.id == item.id;
        });
      });

      if (this.selectedLectors.length > 0) {
        this.getEvents();
      }
    },
    getEvents() {
      let self = this;

      axios
        .get("/schedule/users/events", {
          params: {
            UserIds: this.selectedLectors.map(function(item) {
              return item.id;
            }),
            From: this.from,
            To: this.to
          },
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        })
        .then(response => {
          this.loaded = true;

          this.events = response.data.rows.map(function(item) {
            let event = {
              start: moment(item.startDate).format("YYYY-MM-DD HH:mm"),
              end: moment(item.endDate).format("YYYY-MM-DD HH:mm"),
              id: item.id,
              type: item.type,
              userId: item.userId,
              price: item.price
            };

            let lector =
              self.selectedLectors.filter(function(item2) {
                return item2.id == item.userId;
              })[0] || null;
            if (lector != null) {
              let splitIndex = self.selectedLectors.indexOf(lector);
              if (splitIndex > -1) {
                event.split = splitIndex + 1;
              }
            }

            if (item.type == 5 || item.type == 6) {
              event.content =
                '<span style="padding-left: 4px;" title="Wydarzenie dodatkowe">📋</span>';
            } else {
              event.content = "";
            }

            if (item.lessonStatus != null) {
              if (item.lessonStatus == 0) {
                event.content +=
                  '<span style="padding-left: 4px;" title="Wydarzenie oznaczone jako zrealizowane">✅</span>';
              } else {
                event.content +=
                  '<span style="padding-left: 4px;" title="Wydarzenie oznaczone jako no-show">⛔️</span>';
              }
            }

            if (item.price) {
              event.content += `<span style="padding-left: 4px;" title="Cena zajęć: ${item.price.toFixed(
                2
              )} PLN">💲</span>`;
            }

            switch (item.type) {
              case 0:
                event.class = "bg-available";
                event.name = "Dostępność";
                event.background = true;
                break;
              case 1:
                event.class = "busy";
                event.name = "Niedostępność";
                break;
              case 2:
                event.class = "talk";
                event.name = "Rozmowa";
                break;
              case 3:
                event.class = "lesson";
                event.name = "Lekcja";
                break;
              case 4:
                event.class = "placement-test";
                event.name = "Placement test";
                break;
              case 5:
                event.class = "talk";
                event.name = "Rozmowa dodatkowa";
                break;
              case 6:
                event.class = "lesson";
                event.name = "Lekcja dodatkowa";
                break;
            }
            return event;
          });
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    },
    reloadEvents(state, event) {
      this.from = moment(event.startDate).format("YYYY-MM-DD HH:mm");
      this.to = moment(event.endDate).format("YYYY-MM-DD HH:mm");

      this.getEvents();
    },
    onEventClick(event, e) {
      this.selectedEvent = event;
      this.loading = true;
      this.subjects = null;
      this.previousWords = null;
      this.currentWords = null;

      let eventDate = new Date(this.selectedEvent.start);
      eventDate.setHours(eventDate.getHours());

      axios
        .get("/lessons/event/details/admin/", {
          params: {
            eventId: this.selectedEvent.id,
            userId: this.selectedEvent.userId
          }
        })
        .then(response => {
          this.loaded = true;

          if (response.data.interlocutor != null) {
            this.selectedEvent.interlocutor =
              response.data.interlocutor.firstName +
              " " +
              response.data.interlocutor.lastName;
            this.selectedEvent.phone = response.data.interlocutor.phone;
            this.selectedEvent.skype = response.data.interlocutor.skype;
          }

          this.selectedEvent.isNoShow = response.data.status == 1;
          this.selectedEvent.rating =
            response.data.rating == null ? "-" : response.data.rating;
          this.selectedEvent.comment =
            response.data.comment == null
              ? "-"
              : response.data.comment.replace("\n", "<br />");
          this.selectedEvent.descriptionForStudent =
            response.data.descriptionForStudent;
          this.selectedEvent.descriptionForLector =
            response.data.descriptionForLector;

          if (
            response.data.subjects != null &&
            response.data.subjects.length > 0
          ) {
            this.subjects = response.data.subjects
              .map(function(item) {
                return item.title;
              })
              .join(", ");
          }

          if (
            response.data.currentWords != null &&
            response.data.currentWords.length > 0
          ) {
            this.currentWords = response.data.words
              .filter(function(item) {
                return response.data.currentWords.includes(item.id);
              })
              .map(function(item) {
                return item.term;
              })
              .join(", ");
          }

          if (
            response.data.previousWords != null &&
            response.data.previousWords.length > 0
          ) {
            this.previousWords = response.data.words
              .filter(function(item) {
                return response.data.previousWords.includes(item.id);
              })
              .map(function(item) {
                return item.term;
              })
              .join(", ");
          }
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
          this.showEventDetailsModal = true;
        });

      e.stopPropagation();
    },
    async getLectorsIds() {
      await axios
        .get("lectors/list/ids/")
        .then(response => {
          this.lectorsIds = response.data;
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
        });
    },
    async getLectorsProfiles() {
      await axios
        .get("lectors/list/profiles", {
          params: {
            ids: this.lectorsIds
          },
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        })
        .then(response => {
          response.data.forEach(element => {
            element.displayName = element.firstName + " " + element.lastName;
          });
          this.lectorsProfiles = response.data;
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
        });
    }
  },
  watch: {
    loading: function(newValue) {
      if (newValue) {
        this.loader = this.$loading.show();
      } else {
        this.loader.hide();
      }
    },
    selectedLectors: function() {
      this.lectorsChanged();
    }
  },
  async created() {
    await this.getLectorsIds();
    await this.getLectorsProfiles();
    this.loaded = true;
  }
};
</script>

<style lang="scss">
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}

.vuecal__event.busy {
  background-color: #ffa094 !important;
  color: #000 !important;
}

.vuecal__event.talk {
  background-color: #38ace3 !important;
  color: #fff !important;
}

.vuecal__event.lesson {
  background-color: #fedd94 !important;
  color: #fff !important;
}

.vuecal__event.placement-test {
  background-color: #bce29e !important;
  color: #fff !important;
}

.vuecal__event.available {
  background-color: #fff !important;
  color: #000 !important;
}

.vuecal__event.bg-available {
  background-color: #fff !important;
  color: #000 !important;
  align-items: flex-start !important;
  padding-top: 1em !important;
}

.vuecal__title-bar {
  background-color: #588093 !important;
  color: #fff !important;
}

.lector .vuecal__cell {
  background-color: rgba(0, 0, 0, 0.29) !important;
}

.vuecal__event {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vuecal__event:hover,
.vuecal__event:focus,
.vuecal__event--focus,
.vuecal__event:active {
  z-index: 1 !important;
}

.vuecal__event--background:hover,
.vuecal__event--background:focus,
.vuecal__event--background--focus,
.vuecal__event--background:active {
  z-index: 0 !important;
}

.vld-overlay {
  z-index: 9999 !important;
}

.vuecal__split-days-headers {
  margin: 0px 0px 0px 3em !important;
  height: 48px !important;
}

.day-split-header {
  color: rgba(0, 0, 0, 0.8);
  font-size: 22px;
  padding-top: 6px;
  text-align: center;
  flex-basis: 0 !important;
  height: 48px !important;
  display: inline-block !important;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  overflow: hidden;
}

.vuecal__cell-split.odd {
  background-color: rgba(0, 0, 0, 0.05);
}

.vuecal__cell-split.even {
  background-color: rgba(0, 0, 0, 0.025);
}

.day-split-header.odd {
  background-color: rgba(0, 0, 0, 0.05);
}

.day-split-header.even {
  background-color: rgba(0, 0, 0, 0.025);
}

.multiselect__tag {
  background-color: #38ace3 !important;
  padding-top: 4px !important;
  padding-bottom: 6px !important;
}
</style>